
const countHealthKPIs = (initiative) => {
    if (!initiative || !initiative.KPI || !Array.isArray(initiative.KPI)) {
      return 0;
    }
  
    let valueLinkedCount = 0;
    initiative.KPI.forEach((kpi) => {
      if (kpi && kpi.TypeOfKPI === 'Health') {
        valueLinkedCount++;
      }
    });
  
    return valueLinkedCount;
  };
  
  export default countHealthKPIs;